import { TimerSandPausedIcon } from './TimerSandPausedIcon';

/**
 * author: Jeff Anders
 * id 24C73172-9253-4C99-B214-B1C523115D79
 * name timer-sand-paused
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-sand-paused.svg
 * tags
 * - Date / Time 
 */
export const HourglassPausedIcon = TimerSandPausedIcon;
export default HourglassPausedIcon